const createBlobUrl = (data: any) => window.URL.createObjectURL(new Blob([data]));

export default createBlobUrl;
